// Copyright (c) 2021 Patrick Amrein <amrein@ubique.ch>
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

import React from 'react';
import injectSheet, { Styles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import ITheme from '../../interfaces/ITheme';
import { Button } from '../Button';
import { useAuth } from '../../oauth/privateRoute';

const styles = (theme: ITheme): Styles<string, unknown> => ({
    wrapper: {
        marginLeft: 12,
        minWidth: 130,
        textAlign: 'right',
    },
    button: {
        padding: [3, 19],
        border: `1px solid ${theme.light}`,
        backgroundColor: 'transparent',
        '&:active, &:hover, &:focus': {
            backgroundColor: theme.light,
            color: theme.primary,
            border: `none`,
            padding: [4, 20],
        },
        '&.focus-visible': {
            padding: [2, 18],
            color: theme.primary,
            backgroundColor: theme.light,
            boxShadow: `0 0 0 2pt ${theme.light}`,
            border: `2px solid ${theme.primary}`,
        },
    },
});

const LogoutButton = ({
    classes,
}: {
    classes: Record<string, string>;
}): React.ReactElement => {
    const auth = useAuth();
    const { t } = useTranslation('translation');
    return (
        <div className={classes.wrapper}>
            <Button
                small
                onClick={() => auth.signout()}
                label={t('actions.logout')}
                className={classes.button}
            >
                {t('actions.logout')}
            </Button>
        </div>
    );
};

export default injectSheet(styles)(LogoutButton);
